module.exports = __webpack_public_path__ + "img/5-3.a5118ec7.png";